export const processSteps = [
  {
    id: 1,
    number: "01",
    icon: "compass",
    title: "Define",
    description: "We map your ideal customer profile and the marketing niche your brand should own.",
  },
  {
    id: 2,
    number: "02",
    icon: "search",
    title: "Discover",
    description: "We generate and validate the data set your campaigns will run on, built for your niche.",
  },
  {
    id: 3,
    number: "03",
    icon: "sendHorizontal",
    title: "Deliver",
    description: "Validated data and campaigns go live with quality checks at every handoff.",
  },
  {
    id: 4,
    number: "04",
    icon: "trendingUp",
    title: "Grow",
    description: "We monitor results and refine targeting so performance compounds quarter over quarter.",
  },
];
